import { NgModule } from '@angular/core';
import { DropDownListFilterComponent } from './dropdownlist.component';
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';

@NgModule({
  imports: [
    DropDownListModule
  ],
  declarations: [
    DropDownListFilterComponent
  ],
  exports: [
    DropDownListFilterComponent
  ]
})
export class DropDownListFilterModule { }
